import React from "react"
import styled from "styled-components"

const StyledHeadLine = styled.h4`
  font-size: 1.32em;
  margin-bottom: 20px;
  line-height: 2;
`

const StyledText = styled.p`
  color: ${props => props.theme.colors.text};
`

export default function Overview() {
  return (
    <>
      <StyledHeadLine>個人情報保護方針</StyledHeadLine>
      <StyledText>
        フランソアグループ（以下、「当グループ」といいます）は、個人情報保護を重要な社会的責任であると考えます。個人情報を取り扱う場合の社会的責任を充分に認識し、以下の方針を定め、適正に利用、提供及び管理するとともに正確性・安全性の保持に努めます。
      </StyledText>
    </>
  )
}
